export enum TcohProcedureType {
    eventEcg = 'eventEcg',
    holter = 'holter',
}
